import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiHome, FiPlus, FiEdit2, FiTrash2, FiUsers, FiGrid } from "react-icons/fi";
import { getHostels, deleteHostel } from "../../services/hostelService";

export default function HostelList() {
    const [hostels, setHostels] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const loadHostels = async () => {
        setLoading(true);
        try {
            const res = await getHostels();
            setHostels(res.data || []);
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to load hostels");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadHostels();
    }, []);

    const handleDelete = async (hostel) => {
        if (!window.confirm(`Delete "${hostel.name}"? This only works if it has no rooms.`)) {
            return;
        }

        try {
            await deleteHostel(hostel._id);
            toast.success("Hostel deleted");
            loadHostels();
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to delete hostel");
        }
    };

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title">
                        <FiHome /> Hostel Management
                    </h1>
                    <p className="page-subtitle">{hostels.length} hostel(s)</p>
                </div>
                <Link to="/hostels/new" className="btn btn-primary">
                    <FiPlus /> Add Hostel
                </Link>
            </div>

            <div className="card">
                {loading ? (
                    <div className="loading-center">
                        <div className="spinner" />
                        Loading hostels...
                    </div>
                ) : hostels.length === 0 ? (
                    <div className="empty-state">
                        <p>No hostels added yet.</p>
                    </div>
                ) : (
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Hostel</th>
                                    <th>Type</th>
                                    <th>Warden</th>
                                    <th>Rooms</th>
                                    <th>Capacity</th>
                                    <th>Status</th>
                                    <th style={{ textAlign: "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hostels.map((hostel) => (
                                    <tr key={hostel._id}>
                                        <td>
                                            <div style={{ fontWeight: 600 }}>{hostel.name}</div>
                                            {hostel.address && (
                                                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                                                    {hostel.address}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <span className="badge badge-blue">{hostel.type}</span>
                                        </td>
                                        <td style={{ fontSize: 13 }}>
                                            {hostel.warden?.name || "Not assigned"}
                                            {hostel.warden?.contact && (
                                                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                                                    {hostel.warden.contact}
                                                </div>
                                            )}
                                        </td>
                                        <td>{hostel.totalRooms ?? 0}</td>
                                        <td>{hostel.totalCapacity ?? 0}</td>
                                        <td>
                                            <span className={`badge ${hostel.isActive ? "badge-green" : "badge-muted"}`}>
                                                {hostel.isActive ? "Active" : "Inactive"}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="table-actions" style={{ justifyContent: "flex-end", flexWrap: "wrap" }}>
                                                <button
                                                    className="btn btn-outline btn-sm"
                                                    onClick={() => navigate(`/hostels/${hostel._id}/rooms`)}
                                                >
                                                    <FiGrid /> Rooms
                                                </button>
                                                <button
                                                    className="btn btn-outline btn-sm"
                                                    onClick={() => navigate(`/hostel-allocations?hostel=${hostel._id}`)}
                                                >
                                                    <FiUsers /> Allocations
                                                </button>
                                                <button
                                                    className="btn btn-outline btn-sm"
                                                    onClick={() => navigate(`/hostels/${hostel._id}/edit`)}
                                                >
                                                    <FiEdit2 /> Edit
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(hostel)}
                                                >
                                                    <FiTrash2 /> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}